import React, { useEffect, useRef, useState } from "react";

const RevealOnScroll = ({
  children,
  className = "",
  delay = 0,
  threshold = 0.1,
  direction = "up",
  duration = 800,
  once = true,
}) => {
  const [isVisible, setIsVisible] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          if (once) {
            observer.disconnect();
          }
        } else if (!once) {
          // Reset visibility when scrolling out (only if once is false)
          setIsVisible(false);
        }
      },
      {
        threshold,
        rootMargin: "0px",
      }
    );

    if (ref.current) observer.observe(ref.current);

    return () => observer.disconnect();
  }, [threshold, once]);

  const transitionDelay = delay > 0 ? `${delay}ms` : undefined;
  const transitionDuration = `${duration}ms`;

  const getHiddenClass = () => {
    switch (direction) {
      case "down":
        return "reveal-hidden-down";
      case "left":
        return "reveal-hidden-left";
      case "right":
        return "reveal-hidden-right";
      default:
        return "reveal-hidden-up";
    }
  };

  return (
    <div
      ref={ref}
      className={`reveal-base ${
        isVisible ? "reveal-visible" : getHiddenClass()
      } ${className}`}
      style={{
        transitionDuration,
        ...(transitionDelay && { transitionDelay }),
      }}
    >
      {children}
    </div>
  );
};

export default RevealOnScroll;
